import { IChannelRepository } from '../../ports/IChannelRepository';

export class CreateChannelUseCase {
  constructor(private repo: IChannelRepository) {}
  execute(input: { link: string; title?: string; type: string; isPrivate: boolean; minimalSendingInterval: number; sendingStartTime: string; sendingEndTime: string }) {
    return this.repo.create(input);
  }
}
